import { FlagCircleOutlined } from "@mui/icons-material";

export const flagOutlined = (props) => {
  return <FlagCircleOutlined {...props} />;
};
